import { updateObject } from "../../../../shared";
import {
  emptyString,
  globalConstants,
  managersConstants,
  PAGINATION_DEFAULTS,
  PAGINATION_SENTINELS,
} from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const {
  MANAGERS_DATA,
  RESET_MANAGERS,
  MANAGERS_DETAIL,
  UPDATE_MANAGERS,
  GET_ALL_LOCATIONS,
  MANAGERS_UPDATED_FLAG,
  PAGINATED_MANAGERS_DATA,
  UPDATE_MANAGERS_RESPONSE,
} = managersConstants;

const initialState = {
  allManagers: [],
  filteredManagers: [],
  managers: [],
  managerId: 0,
  managerDetails: [],
  allLocations: [],
  allManagerLocations: [],
  collectiveData: {},
  managerUpdateResponse: emptyString,
  managerDataPagination: {
    ...PAGINATION_DEFAULTS,
    number: PAGINATION_SENTINELS.UNLOADED_PAGE_INDEX,
  },
  managerUpdatedFlag: false,
};

export const managersReducer = (state = initialState, action) => {
  switch (action.type) {
    case MANAGERS_DATA + SUCCESS:
      return updateObject(state, {
        allManagers: [...state.allManagers, ...(action?.data?.data || [])],
        filteredManagers: [],
      });
    case PAGINATED_MANAGERS_DATA + SUCCESS:
      return updateObject(state, {
        allLocations: action.data.pageData,
        managerDataPagination: action.data.page,
        collectiveData: action.data.componentData,
      });
    case MANAGERS_DETAIL + SUCCESS:
      return updateObject(state, { managerDetails: action.data });
    case RESET_MANAGERS + SUCCESS:
      return updateObject(state, {
        allManagers: [],
      });
    case GET_ALL_LOCATIONS + SUCCESS:
      return updateObject(state, {
        allLocations: action.data,
      });
    case UPDATE_MANAGERS + FAILURE:
    case UPDATE_MANAGERS_RESPONSE + SUCCESS:
      return updateObject(state, {
        managerUpdateResponse: action.data,
      });
    case MANAGERS_UPDATED_FLAG + SUCCESS:
      return updateObject(state, {
        managerUpdatedFlag: action.data,
      });
    default:
      return state;
  }
};
